import React, { useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  BackHandler,
} from "react-native";

import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import InputPersonas from "../components/InputPersonas";
import ButtonLayout from "../components/ButtonLayout";

export default function UserScreen(props) {
  const [adultos, setAdultos] = useState(0);
  const [ninos, setNinos] = useState(0);
  const [failed, setFailed] = useState(false);
  const paso2 = () => {
    if (!ninos || ninos == NaN) setNinos(0);
    if (!adultos || adultos == NaN) setAdultos(0);
    if (
      parseInt(adultos) >= 1 &&
      Math.floor(ninos) >= 0 &&
      parseInt(adultos) + parseInt(ninos) <=
        props.route.params.instalaciones.maximoPersonas
    ) {
      setNinos(Math.floor(ninos));
      props.navigation.navigate("Paso2Cita", {
        ...props.route.params,
        ninos: ninos,
        adultos: adultos,
      });
    } else setFailed(true);
  };
  return (
    <BackgroundUser scroll={true}>
      <Logo navigation={props.navigation}></Logo>
      <View style={{ flex: 1, justifyContent: "center" }}>
        <Title style={{ fontFamily: "Nunito-Bold" }}>Número de personas</Title>
        <Text style={{ textAlign: "center", margin: 10 }}>
          <Text
            style={{
              fontFamily: "Nunito-Bold",
              fontSize: 18,
              color: "#3E4672",
            }}>
            Número de adultos{" "}
          </Text>
          <Text
            style={{
              fontFamily: "Nunito-Regular",
              fontSize: 16,
              color: "#3E4672",
            }}>
            (Mayores de 16 años)
          </Text>
        </Text>
        <InputPersonas
          placeholder={"" + adultos}
          onChangeText={(per) => {
            if (per) setAdultos(parseInt(per));
            else setAdultos(0);
          }}
          value={"" + adultos}
        />
        <Text style={{ textAlign: "center", margin: 10 }}>
          <Text
            style={{
              fontFamily: "Nunito-Bold",
              fontSize: 18,
              color: "#3E4672",
            }}>
            Número de niños
          </Text>
        </Text>
        <InputPersonas
          placeholder={"" + ninos}
          onChangeText={(per) => {
            if (per) setNinos(parseInt(per));
            else setNinos(0);
          }}
          value={"" + ninos}
        />
        {failed && (
          <Title style={{ fontSize: 15 }}>Parámetros no válidos</Title>
        )}
        <ButtonLayout text='Aceptar' onPress={() => paso2()} />
      </View>
    </BackgroundUser>
  );
}
